export interface UserInfo {
    firstName: string;
    lastName: string;
    email: string;
    loginName: string;
    accountId: string;
    password: string;
    roles: string;
}

export interface passwordInfo {
    newPassword: string;
    oldPassword: string;
}

export interface AliasLoginInfo {
    loginName?: string;
    accountId?: string;
}

export interface AccountSearchListModel {
    accountName: string;
    accountId: string;
}

export interface AccountContact {
    out_accountcode: string;
    out_administrator: string;
    out_annuity_exp_ups: string;
    out_customer_name: string;
    out_border_eta_ups: string;
    out_data_feed: string;
    out_email: string;
    out_first_name: string;
    out_invoices: string;
    out_login_id: string;
    out_message: string;
    out_middle_name: string;
    out_order_confs: string;
    out_order_status_ups: string;
    out_page_no: number;
    out_promotions: string;
    out_purch_officer: string;
    out_record_count: number;
    out_result_status: string;
    out_salutation: string;
    out_shipping_reports: string;
    out_statements: string;
    out_stock_catalogue: string;
    out_surname: string;
    out_bus_phone_no: string;
    out_status: string;
}

export class GetDebtorSummary {
    out_balance: number;
    out_order_count: number;
    out_order_value?: number;
    out_quote_count: number;
    out_quote_value: number;
    constructor() {
        this.out_balance = 0.00;
        this.out_order_count = 0;
        this.out_order_value = 0.00;
        this.out_quote_count = 0;
        this.out_quote_value = 0.00;
    }
}


export class GetDebtorHistory {
    out_01_jan: string;
    out_02_feb: string;
    out_03_mar: string;
    out_04_apr: string;
    out_05_may: string;
    out_06_jun: string;
    out_07_jul: string;
    out_08_aug: string;
    out_09_sep: string;
    out_10_oct: string;
    out_11_nov: string;
    out_12_dec: string;
    out_period: string;
    constructor() {
        this.out_01_jan = '0.00';
        this.out_02_feb = '0.00';
        this.out_03_mar = '0.00';
        this.out_04_apr = '0.00';
        this.out_05_may = '0.00';
        this.out_06_jun = '0.00';
        this.out_07_jul = '0.00';
        this.out_08_aug = '0.00';
        this.out_09_sep = '0.00';
        this.out_10_oct = '0.00';
        this.out_11_nov = '0.00';
        this.out_12_dec = '0.00';
    }
}

